/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $AddBed = {
    properties: {
        name: {
    type: 'string',
    isRequired: true,
},
    },
};